<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>
    <div class="modal-body">
        <form>
            <div class="form-row">
                <div class="form-group col-md-8">
                    <label for="email">Email Address</label>
                    <!-- setting autocomplete to a random string prevents the browser from trying to autofill -->
                    <input class="form-control" type="email" autocomplete="new-password"
                        [(ngModel)]="data.Email" name="email" placeholder="Enter email address"
                        [ngbTypeahead]="searchAccounts" (selectItem)="accountLookupSelected($event.item)" />
                        <div *ngIf="emailExists()" class="user-type">
                                existing user
                        </div>
                </div>
                <div *ngIf="!emailExists()" class="form-group col-md-6" style ="margin-top: 1vh">
                    <label for="accountName">Full Name</label>
                    <input [(ngModel)]="data.Name" id="accountName" name="name" class="form-control">
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting"></app-loading-spinner>
    </div>
</ng-template>

<button *ngIf="currentAssignee" class="btn btn-primary open-button" (click)="openForEdit()">Assign this task to a member of your team</button>
<button *ngIf="!currentAssignee" class="btn btn-primary open-button" (click)="openForNew()">Assign this task to a member of your team</button>
